/** Outbox ids sent from this browser session, so realtime events can report their outcome. */
export const pendingSends = new Set<string>()
